import React from "react";
import "./AccountSafely.css";
import image1 from "./01JSPEVJFY7TM6SJZX3F9G5RXP.svg";
import image3 from "./01JSPEVJG08AQZBXBJGFACQRFP.svg";
import image2 from "./01JSPEVJG1YBSCGH88NKRZAZ97.svg";
import { Link } from "react-router-dom";
function AccountSafely() {
  return (
    <>
      <section className="account-safely-section mb-3">
        <div className="container">
          <div className="account-safely-header-title">
            <h5>
              Investing in stocks, Crypto, ETFs, and commodities carries risks.
              Conduct your own research before concluding a transaction.
            </h5>
            <h5>
              *Stocks and ETFs are the underlying assets of the contracts
              offered as WLF Mobile Stocks and are brought to you by WLF
              Finance Financial Services GmbH.
            </h5>
          </div>
        </div>
      </section>

      <section className="account-safely-section">
        <div className="container">
          <div className="account-safely-header">
            <h2>Fund Your Account Safely and Securely</h2>
            <p>
              Trade with a forward thinking broker that has built long-standing
              partnerships
              <br />
              with industry leading providers to ensure your funds are always
              secure.
            </p>
          </div>
          <div className="account-safely-card-area">
            <div className="account-safely-card-area-title">
              <h5>Start trading in 3 easy steps</h5>
            </div>
            <div className="account-safely-card-items-area">
              <div className="account-safely-card-item-area">
                <div className="account-safely-card">
                  <div className="account-safely-card-item">
                    <div className="account-safely-card-image">
                      <img src={image1} alt="" />
                      <p>1</p>
                    </div>
                    <div className="account-safely-card-content">
                      <h6>Register </h6>
                      <p>Create a profile in less than 1 minute</p>
                    </div>
                  </div>
                </div>
                <div className="account-safely-arrow-area my-3">
                  <i className="fa-solid fa-arrow-down"></i>
                </div>
              </div>
              <div className="account-safely-card-item-area">
                <div className="account-safely-card">
                  <div className="account-safely-card-item">
                    <div className="account-safely-card-image">
                      <img src={image3} alt="" />
                      <p>2</p>
                    </div>
                    <div className="account-safely-card-content">
                      <h6>Deposit </h6>
                      <p>Fund your account via your chosen method</p>
                    </div>
                  </div>
                </div>
                <div className="account-safely-arrow-area my-3">
                  <i className="fa-solid fa-arrow-down"></i>
                </div>
              </div>
              <div className="account-safely-card-item-area">
                <div className="account-safely-card">
                  <div className="account-safely-card-item">
                    <div className="account-safely-card-image">
                      <img src={image2} alt="" />
                      <p>3</p>
                    </div>
                    <div className="account-safely-card-content">
                      <h6>Trade </h6>
                      <p>Start trading with Tradesmart</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="account-safely-link pt-4 mt-3 pb-3 text-center">
            <Link to="/register">Start Trading</Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default AccountSafely;
